import {
  Avatar,
  getAvatarList,
  getAvatars,
  getEventId,
  getExtraGuestsAmount,
  getExtraGuestsCount,
  isEventV3,
  isRsvp,
} from '@wix/wix-events-commons-statics'
import {widgetDataHooks as DH} from '@wix/wix-events-data-hooks'
import {AvatarGroup, AvatarGroupSize, HoverStyles} from '@wix/wix-ui-tpa/cssVars'
import {useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import _ from 'lodash'
import React from 'react'
import {useWidgetActions, useWidgetState} from '../../hooks/state-provider'
import {getEventMembers} from '../../selectors/members'
import {isMembersVisible as isListMembersVisible, isSingleEventWidget} from '../../selectors/settings'
import {isMembersVisible} from '../../selectors/single-settings'
import {getEventAttendingGuests} from '../../selectors/total-guests'
import {MembersProps} from './interfaces'
import {classes} from './members.st.css'

const MAX_AVATARS = 3

export const Members = ({event, onImage, singleLayout, calendarLayout, listLayout}: MembersProps) => {
  const {t} = useTranslation()

  const showMembers = useWidgetState(state =>
    isSingleEventWidget(state.component) ? isMembersVisible(state, event) : isListMembersVisible(state, event),
  )

  let totalAttendingGuests = useWidgetState(state => getEventAttendingGuests(state, getEventId(event)))

  const membersFromState = useWidgetState(state => getEventMembers(state, getEventId(event)))

  let items: Avatar[]
  let extraGuests: number

  if (isEventV3(event)) {
    items = getAvatarList(membersFromState ?? [], totalAttendingGuests, MAX_AVATARS, showMembers)
    extraGuests = getExtraGuestsAmount(totalAttendingGuests, MAX_AVATARS)
  } else {
    const extendedEvent = event as ExtendedEvent

    totalAttendingGuests = isRsvp(event)
      ? ((extendedEvent.totalGuests as TotalRsvpEventGuests)?.YES ?? 0)
      : ((extendedEvent.totalGuests as number) ?? 0)

    items = getAvatars(extendedEvent.members, totalAttendingGuests, isRsvp(extendedEvent), MAX_AVATARS, showMembers)
    extraGuests = getExtraGuestsCount(totalAttendingGuests, MAX_AVATARS)
  }

  const {openMembersModal} = useWidgetActions()

  const handleClick = (e: React.MouseEvent | React.KeyboardEvent) => {
    e.stopPropagation()
    openMembersModal(event.id)
  }

  let avatarsClass = classes.avatarsDefault

  if (onImage) {
    avatarsClass = classes.avatarsOnImage
  } else if (singleLayout) {
    avatarsClass = classes.avatarsSingleLayout
  } else if (calendarLayout) {
    avatarsClass = classes.avatarsCalendarLayout
  } else if (listLayout) {
    avatarsClass = classes.avatarsListLayout
  }

  return (
    <div className={classes.root}>
      <AvatarGroup
        {...{className: classNames(avatarsClass)}}
        maxAmount={MAX_AVATARS}
        items={items}
        size={AvatarGroupSize.small}
        data-hook={DH.members}
      >
        <AvatarGroup.TextButton
          onClick={handleClick}
          className={classes.avatar}
          aria-haspopup="dialog"
          aria-label={t('members.guestDetails')}
          hoverStyle={HoverStyles.underline}
        >
          {extraGuests ? t('members.moreLink', {amount: extraGuests}) : t('members.seeAll')}
        </AvatarGroup.TextButton>
      </AvatarGroup>
    </div>
  )
}
